import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { SxProps, Theme } from "@mui/material/styles";
import { useTheme } from "@quales/utils/theme";
import { IconType } from "react-icons";
import { Icon, IconButton, Tooltip } from "@mui/material";

export type CustomTextFieldProps = Omit<TextFieldProps, "size" | "color"> & {
  controldisabled?: boolean;
  useFullWidth?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
  iconButton?: {
    icon: IconType;
    onClick: () => void;
    tooltip?: string;
    color?:
      | "disabled"
      | "error"
      | "primary"
      | "secondary"
      | "info"
      | "success"
      | "warning"
      | "inherit"
      | "action";
  };
};

export const CustomTextField = ({
  size = "small",
  useFullWidth = true,
  controldisabled,
  value,
  iconButton,
  sx,
  ...props // Non-mask props
}: CustomTextFieldProps) => {
  const theme = useTheme();

  const iconBtn = iconButton ? (
    iconButton.tooltip ? (
      <Tooltip title={iconButton.tooltip}>
        <IconButton onClick={iconButton.onClick}>
          <Icon
            component={iconButton.icon}
            color={iconButton.color || "inherit"}
          />
        </IconButton>
      </Tooltip>
    ) : (
      <IconButton onClick={iconButton.onClick}>
        <Icon
          component={iconButton.icon}
          color={iconButton.color || "inherit"}
        />
      </IconButton>
    )
  ) : null;

  return (
    <TextField
      {...props}
      inputProps={{ ...props.inputProps, readOnly: controldisabled }}
      fullWidth={useFullWidth}
      disabled={controldisabled}
      value={value || ""}
      size={size}
      error={props.error}
      required={props.required}
      sx={[
        {
          "&.MuiTextField-root .Mui-disabled ": {
            opacity: 0.9,
            pointerEvents: "unset",
            "&&:hover": {
              cursor: "default",
            },
          },
          "& .MuiInputBase-input.Mui-disabled": {},
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      InputProps={{
        ...props.InputProps,
        startAdornment: iconBtn ? iconBtn : props.InputProps?.startAdornment,
      }}
    />
  );
};

export default CustomTextField;
